import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';

// Components
import SalesReturnAllocationsTable from "./SalesReturnAllocationsTable";
import CollectionPaymentTable from "./CollectionPaymentTable";
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import {isLoggedIn} from "../../../components/Cookies/Cookies";
import {PDFDownloadLink} from '@react-pdf/renderer';
import {CollectionViewPdf} from "../../../components/PDF/CollectionViewPdf";
import Preloader from "../../../components/Preloader/Preloader";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
});

const CollectionView = () => {
	const { drpayno, useridNo } = useParams();
	const [soInfo, setSoInfo] = useState(null);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in item table
	const [allocations, setAllocations] = useState([]); //data to display in payment table
	const [showPDF, setShowPdf] = useState(false);
	let history = useHistory();

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const data = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'collection_view_details', {
			params:{
				drpayno: drpayno,
				jc_user_id_no: useridNo
			}
		}).then((res)=>{
			setItems(res.data.data.payment_info);
			setAllocations(res.data.data.allocations);
			setSoInfo(res.data.data.general_info);
			setShowPdf(true);
		}).catch((error)=>{
		//console.log(error.message);
		})
	};	

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/sales"}><h4 style={{color:"#339933"}}>Sales</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/sales/collection-history"}><h4 style={{color:"#339933"}}>Collection</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Collection View #{drpayno}</h4>
			</div>

			{soInfo?(<div className="page-container">
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									Collection View
								</div>
								<div className={classes.title}>
									Collection View
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Collected From: 
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{soInfo.collected_from || "Collected From"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Branch
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{soInfo.branch || "Branch"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Contact #:
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{soInfo.contact_no || "Contact Number"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Address:
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{soInfo.address || "Address"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Total:
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{soInfo.total || "Total"}
								</Grid>
							</Grid>
						</div>
						<h4>Allocations</h4>
						<SalesReturnAllocationsTable items={allocations}/>
						<h4>Payments</h4>
						<CollectionPaymentTable items={items}/>	
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(soInfo.total).format('0,0.00')}
								</div>	
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={soInfo.notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>
					</CardContent>
				</Card>
				<div className={classes.buttonContainer}>
						{showPDF && <PDFDownloadLink
										document={<CollectionViewPdf cvDetails={soInfo} payment={items} allocations={allocations} drpayno={drpayno}/>}
										fileName={"Collection#"+drpayno+".pdf"}
										style={{
											textDecoration: "none",
											padding: "6px 8px 10px",
											color: "#fff",
											display:"inline-block",
											marginBottom:"7px",
											fontFamily: "Ubuntu",
											backgroundColor: "#339933",
											border: "1px solid #339933",
											borderRadius: "4px"
											}}
									    >
										{({ blob, url, loading, error }) =>
										loading ? "Loading document..." : "Print"
										}
						</PDFDownloadLink>}
				</div>
			</div>
		):(<Preloader />)}


		</div>
	);
};

export default CollectionView;
